(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zypher-collection-filter-fallback"] && !Shopify.designMode) return;
  try {
    (() => {
    const desktop = window.matchMedia('(min-width: 990px)');
    const initialise = () => {
      document.querySelectorAll('[data-zypher-responsive-filter]').forEach((panel) => {
        if (panel.dataset.zypherFilterReady) return;
        panel.dataset.zypherFilterReady = 'true';
        panel.open = desktop.matches;
      });
    };
    initialise();
    desktop.addEventListener('change', () => {
      document.querySelectorAll('[data-zypher-responsive-filter]').forEach((panel) => {
        panel.open = desktop.matches;
      });
    });
    const content = document.getElementById('MainContent');
    if (content) {
      new MutationObserver((records) => {
        const addedFilter = records.some((record) => Array.from(record.addedNodes).some((node) =>
          node.nodeType === 1 && (node.matches('[data-zypher-responsive-filter]') || node.querySelector('[data-zypher-responsive-filter]'))
        ));
        if (addedFilter) initialise();
      }).observe(content, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', initialise);
  })();
  } catch(e) { console.error(e); }
})();

})();
